import { render, staticRenderFns } from "./releaseUpload.vue?vue&type=template&id=0425a832"
import script from "./releaseUpload.vue?vue&type=script&lang=js"
export * from "./releaseUpload.vue?vue&type=script&lang=js"
import style0 from "./releaseUpload.vue?vue&type=style&index=0&id=0425a832&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports